<template>
  <hcc-modal
    name="campaigns-modal"
    :title="$t('campaigns.title')"
    @confirm="handleConfirm"
    @closed="cleanCampaign"
    :scrollable="false"
    :confirmDisableButton="!selectCampaign"
  >
    <div class="example-modal-form">
      <div class="campaigns-modal">
        <div>
          <span> {{ $t("multimedia.campaigns-assigned") }} </span>
          <span class="campaigns-modal__user">{{ user }} </span>
        </div>
        <div class="campaigns-modal__databank">
          {{ $t("multimedia.messages-campaign") }}
        </div>
        <div class="campaigns-modal__databank">
          {{ $t("multimedia.databank-from") }}
        </div>
      </div>
      <hcc-select
        option-label="name"
        track-by="id"
        :options="campaigns"
        placeholder="Select a campaign"
        v-model="selectCampaign"
        customClass="select"
      />
    </div>
  </hcc-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import HccModal from '@/components/shared/HccModal/index.vue';
import HccSelect from '@/components/shared/HccSelect/index.vue';

export default {
  components: {
    HccModal, HccSelect,
  },
  data() {
    return {
      selectCampaign: null,
    };
  },
  computed: {
    ...mapGetters([
      'getUserCampaigns',
      'userInfo',
    ]),
    campaigns() {
      return this.getUserCampaigns;
    },
    conversation() {
      return !this.isHistory
        ? this.activeConversation.conversation
        : this.activeConversationHistory.conversation;
    },
    campaign() {
      return this.conversation.campaign;
    },
    user() {
      return this.userInfo.name;
    },

  },
  methods: {
    handleConfirm() {
      this.$emit('confirm-campaign', this.selectCampaign);
    },
    cleanCampaign() {
      this.selectCampaign = null;
    },

  },
};
</script>

<style lang="scss" scoped>
@import "~styles/components/campaigns-modal.scss";
</style>
